import type { ReactNode } from "react";

type BannerTone = "info" | "ok" | "warning" | "error" | "violet";

type BannerProps = {
  readonly children: ReactNode;
  readonly icon?: string;
  readonly tone?: BannerTone;
};

const toneClasses = {
  error: "border-red-200 bg-red-50 text-red-900",
  info: "border-blue-300 bg-blue-50 text-blue-950",
  ok: "border-emerald-300 bg-emerald-50 text-emerald-950",
  violet: "border-violet-300 bg-violet-50 text-violet-900",
  warning: "border-yellow-300 bg-row-warning text-yellow-950",
} as const satisfies Record<BannerTone, string>;

export function Banner({ children, icon = "i", tone = "info" }: BannerProps) {
  return (
    <div
      className={`mb-4 flex items-start gap-3 rounded-panel border px-4 py-3 text-[13px] ${toneClasses[tone]}`}
    >
      <span className="w-4 shrink-0 text-center font-mono font-bold">
        {icon}
      </span>
      <div className="flex-1 leading-6">{children}</div>
    </div>
  );
}
